import { globalApiHandler } from "../../services/services";
import { createBrowserHistory } from "history";
import { config } from "../../config/appConfig";
import axios from "axios";
const history = createBrowserHistory();


export const BILLING = {
  getBillingDetail: {
    success: "GET_BILLING_DETAILS"
  },
  upgradePlan: {
    start: "UPGRADE_PLAN_START",
    success: "UPGRADE_PLAN_SUCCESS",
    error: "UPGRADE_PLAN_ERROR"
  }
};

export const getBillingDetail = username => {
  let url = `/ntrac/makePayment/transcations?username=${username}`;
  return dispatch => {
    return globalApiHandler(url, "get")
      .then(response => {
        const data = response.data.data;
        dispatch({ type: BILLING.getBillingDetail.success, data });
        return true;
      })
      .catch(err => {
        dispatch({ type: "SERVER_ERROR", data: err.data });
        return false;
      });
  };
};

const updateUserPlan = planId => {
  const currentProfile = JSON.parse(localStorage.getItem("userProfile"));
  currentProfile["subscriptionId"] = planId;
  localStorage.setItem("userProfile", JSON.stringify(currentProfile));
};

export const upgradePlan = requestData => {
  let url = `/ntrac/makePayment/upgradeSubscription?planId=${requestData.planId}&username=${requestData.username}`;
  return function(dispatch) {
    dispatch({ type: BILLING.upgradePlan.start, data: "" });
    globalApiHandler(url, "post", {})
      .then(response => {
        const data = response.data;
        updateUserPlan(requestData.planId);
        dispatch({ type: BILLING.upgradePlan.success, data });
      })
      .catch(error => {
        const data = error.data.message;
        console.log(error.data);
        dispatch({ type: BILLING.upgradePlan.error, data });
      });
  };
};

export const placeOrderAction = requestData => {
  let url = `/ntrac/makePayment/subscribe`;
  return function(dispatch) {
    dispatch({ type: BILLING.upgradePlan.start, data: "" });
    globalApiHandler(url, "post", requestData)
      .then(response => {
        const data = response.data;
        updateUserPlan(requestData.planId);
        dispatch({ type: BILLING.upgradePlan.success, data });
      })
      .catch(error => {
        const data = error.data.message;
        console.log(error.response);
        dispatch({ type: BILLING.upgradePlan.error, data });
      });
  };
};

// export const counterpartyOrder = requestData => {
//   let url = `/ntrac/makePayment/counterparty-payment`;
//   return function(dispatch) {
//     dispatch({ type: BILLING.upgradePlan.start, data: "" });
//     globalApiHandler(url, "post", requestData)
//       .then(response => {
//         const data = response.data;
//         updateUserPlan(requestData.planId);
//         dispatch({ type: BILLING.upgradePlan.success, data });
//       })
//       // .catch(error => {
//       //   const data = error.data.message;
//       //   console.log(error.response);
//       //   dispatch({ type: BILLING.upgradePlan.error, data });
//       // });
//   };
// };
export const counterpartyOrder = requestData => {
  let url = `${config.BASE_URL}/ntrac/makePayment/counterparty-payment`;
  return function(dispatch) {
    dispatch({ type: BILLING.upgradePlan.start, data: "" });
    axios
      .post(url, requestData)
      .then(response => {
        const data = response.data.data;
        dispatch({ type: BILLING.upgradePlan.success, data });
        let temp =JSON.parse(localStorage.getItem('userProfile'))
        temp['subscriptionId'] = 5
        localStorage.setItem('userProfile', JSON.stringify(temp))
      })
      .catch(error => {
        const data = error.response.data.message;
        console.log(error.response);
        dispatch({ type: BILLING.upgradePlan.error, data });
      });
  };
};



// WEBPACK FOOTER //
// ./src/modules/billing/action.js